import React from 'react';
import { type Question } from '../../content/types';
import { VisualAidFactory } from '../../visuals';
import { LatexRenderer } from '../../components/ui/LatexRenderer';
interface AssessmentQuestionCardProps {
  question: Question;
  children: React.ReactNode;
}
export function AssessmentQuestionCard({
  question,
  children
}: AssessmentQuestionCardProps) {
  const stimulusVisuals = question.stimulusAids ?? [];
  return <div className="w-full max-w-3xl mx-auto" data-id="element-830">
      <div className="bg-white rounded-2xl md:rounded-3xl shadow-lg overflow-hidden relative" data-id="element-831">
        {/* Assessment Accent Strip */}
        <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-indigo-500 via-indigo-400 to-indigo-500" data-id="element-832" />

        {/* Question Text */}
        <div className="p-6 sm:p-8 md:p-10 border-b border-slate-100 bg-white pt-8 sm:pt-10" data-id="element-833">
          <div className="text-fluid-xl md:text-fluid-2xl font-bold text-slate-800 leading-relaxed whitespace-pre-line tracking-tight" data-id="element-834">
            <LatexRenderer content={question.question} data-id="element-835" />
          </div>
        </div>

        {/* Stimulus Aids Zone */}
        {stimulusVisuals.length > 0 && <div className="p-6 sm:p-8 bg-slate-50/80 border-b border-slate-100 space-y-6" data-id="element-836">
            {stimulusVisuals.map((aid, index) => <VisualAidFactory key={index} visualAid={aid} isCorrect={undefined} mode="stimulus" data-id="element-837" />)}
          </div>}

        {/* Answer Area */}
        <div className="p-6 sm:p-8 bg-slate-50/50" data-id="element-838">{children}</div>
      </div>
    </div>;
}